import type {SupportPerson, SupportTicket} from './support-types';
export interface InboxSnapshot {
  tickets: SupportTicket[]; people: Record<string, SupportPerson>; origin: string;
  nextCursor: string | null;
}
/** Owned by the signed-in App; never persisted or shared between users. */
export class SupportInboxCache {
  private snapshots = new Map<string, {saved: number; snapshot: InboxSnapshot}>();
  agents?: {saved: number; people: SupportPerson[]};
  get(key: string) {
    const entry = this.snapshots.get(key);
    return entry && Date.now() - entry.saved < 120000 ? entry.snapshot : undefined;
  }
  set(key: string, snapshot: InboxSnapshot) {
    if (this.snapshots.size >= 12 && !this.snapshots.has(key)) this.snapshots.delete(this.snapshots.keys().next().value!);
    this.snapshots.set(key, {saved: Date.now(), snapshot});
  }
  clear() {this.snapshots.clear();}
}
